import React from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";

class BarChart extends React.Component {
  render() {
    const chartOptions = {
      chart: {
        type: "bar",
        height: 600,
      },
      colors: ['#008BD2'],
      title: {
        text: this.props.title || "Bar Chart Title"
      },
      xAxis: {
        categories: this.props.category || []
      },
      yAxis: {
        title: {
          text: this.props.titley||"Cantidad"
        }
      },
      tooltip: {
        headerFormat:
          '<span  style="color:{point.color}">{point.y}</span> Denuncias presentadas en <span  style="color:{point.color}">{point.key}</span>',
        pointFormat:"",
        footerFormat: "",
        shared: false,
        useHTML: false
      },
      series: this.props.datos || [] ,
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true
          },
          enableMouseTracking: true
        }
      },
      credits: {
        enabled: false
      },
      lang: {
        noData: "No hay datos para mostrar" //the text to be displayed
      },
      noData: {
        position: {
          x: 0,
          y: 0,
          align: "center",
          verticalAlign: "middle"
        }
      },
      exporting: {
        buttons: {
          contextButton: {
            menuItems: [{
              text: "Imprimir",
              textKey: 'printChart',
              onclick: function () {
                this.print();
              }
            }, {
              text: "Descargar como PNG",
              textKey: 'downloadPNG',
              onclick: function () {
                this.exportChart();
              }
            }, {
              text: "Descargar como JPEG",
              textKey: 'downloadJPEG',
              onclick: function () {
                this.exportChart({
                  type: 'image/jpeg'
                });
              }
            }, {
              text: "Descargar como PDF",
              textKey: 'downloadPDF',
              onclick: function () {
                this.exportChart({
                  type: 'application/pdf'
                });
              }
            }]
          }
        }
      }
    };
    return (
      <div>
        <HighchartsReact highcharts={Highcharts} options={chartOptions} />
      </div>
    );
  }
}

export default BarChart;
